import styled from "styled-components";

export const Container = styled.div `
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 3;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.45);
    cursor: pointer;
`